if (!customElements.get("media-carousel")) {
  customElements.define(
    "media-carousel",
    class MediaCarousel extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const element = this.querySelector(".keen-slider");

        const config = this.getConfig();
        const autoplayEnabled = this.getAttribute("autoplay") === "true";
        const updateColorsEnabled =
          this.getAttribute("update-colors") === "true";

        const plugins = [this.responsivePlugin, this.markActiveSlidePlugin];
        if (this.querySelector(".keen-nav")) plugins.push(this.navPlugin);
        if (this.querySelector(".keen-dots")) plugins.push(this.dotsPlugin);
        if (updateColorsEnabled && this.querySelector(".waypoint-trigger"))
          plugins.push(this.updateColorsPlugin);
        if (autoplayEnabled) plugins.push(this.autoplayPlugin);

        this.slider = element ? new KeenSlider(element, config, plugins) : null;

        this.slider.slides.forEach((slide, index) => {
          if (slide.dataset.url) {
            slide.addEventListener("click", () => {
              window.location = slide.dataset.url;
            });
          }
        });
      }

      disconnectedCallback() {
        if (this.slider) {
          this.slider.destroy();
          delete this.slider;
        }
      }

      getResponsiveAttribute(attrName) {
        const desktopAttrValue = this.getAttribute(attrName + "-desktop");
        const mobileAttrValue = this.getAttribute(attrName + "-mobile");
        const attrValue = this.getAttribute(attrName);

        if (this.isWindowMobile()) {
          return mobileAttrValue !== undefined && mobileAttrValue !== null
            ? mobileAttrValue
            : attrValue;
        } else {
          return desktopAttrValue !== undefined && desktopAttrValue !== null
            ? desktopAttrValue
            : attrValue;
        }
      }

      getConfig() {
        const loopEnabled =
          this.getResponsiveAttribute("loop") !== undefined
            ? this.getResponsiveAttribute("loop") === "true"
            : // Default behaviour is to loop
              true;
        const numSlidesPerView =
          parseFloat(this.getResponsiveAttribute("slides-per-view")) || 1;
        const slideOrigin =
          this.getResponsiveAttribute("slide-origin") || "auto";
        const slideSpacing = parseFloat(
          this.getResponsiveAttribute("slide-spacing")
        );

        return {
          loop: loopEnabled,
          slides: {
            perView: numSlidesPerView,
            origin: slideOrigin,
            spacing: slideSpacing,
          },
        };
      }

      /**
       * Marks the active slide with a CSS class.
       */
      markActiveSlide(slider) {
        slider.slides.forEach(($slide, index) => {
          if (index === slider.track.details.rel) {
            $slide.classList.add("keen-slider__slide--active");
          } else {
            $slide.classList.remove("keen-slider__slide--active");
          }
        });
      }

      markActiveSlidePlugin(slider) {
        const wrapper = slider.container.parentElement;

        slider.on("created", () => {
          wrapper.markActiveSlide(slider);
        });
        slider.on("optionsChanged", () => {
          wrapper.markActiveSlide(slider);
        });
        slider.on("slideChanged", () => {
          wrapper.markActiveSlide(slider);
        });
      }

      /**
       * Update the colors based on the slide and the waypoint.
       */
      updateColors(slider) {
        const activeSlideIndex = slider.track.details.rel;
        const activeSlide = slider.slides[activeSlideIndex];

        const updatedColorMobile =
          "body-slide-" + activeSlide.dataset.colorMobile;
        const updatedColor = "body-slide-" + activeSlide.dataset.color;

        document.body.dataset.bodyMenu = updatedColor;
        document.body.dataset.bodyAssets = updatedColor;
        document.body.dataset.bodySearch = updatedColor;
        document.body.dataset.bodyPlayPause = updatedColor;
        document.body.dataset.bodyMobileAssets = updatedColor;
        document.body.dataset.bodyMobileSearch = updatedColorMobile;
        document.body.dataset.bodyMobilePlayPause = updatedColorMobile;
      }

      updateColorsPlugin(slider) {
        const wrapper = slider.container.parentElement;

        slider.on("created", () => {
          wrapper.updateColors(slider);

          debugLog("updateColorsPlugin", slider);

          const siteNav = document.querySelector(".site-nav");
          const mobileBtn = document.querySelector(
            "#search-header--mobile.colour-change-mobile"
          );
          const desktopBtn = document.querySelector(
            ".site-header__mobile-cart-mini.colour-change-mobile"
          );
          const wishlistBtn = document.querySelector(
            ".swym-wishlist.patou-wishlist"
          );

          mobileBtn?.classList.add("colour-change");
          desktopBtn?.classList.add("colour-change");
          wishlistBtn?.classList.add("colour-change");

          if (wrapper.waypoint) wrapper.waypoint.destroy();
          wrapper.waypoint = new Waypoint({
            element:
              slider.container.parentElement.querySelector(".waypoint-trigger"),
            handler: function handler(direction) {
              if (direction == "down") {
                siteNav?.classList.remove("colour-change");
                mobileBtn?.classList.remove("colour-change");
                desktopBtn?.classList.remove("colour-change");
                wishlistBtn?.classList.remove("colour-change");
              }

              if (direction == "up") {
                siteNav?.classList.add("colour-change");
                mobileBtn?.classList.add("colour-change");
                desktopBtn?.classList.add("colour-change");
                wishlistBtn?.classList.add("colour-change");
              }
            },
          });
        });

        slider.on("slideChanged", () => {
          wrapper.updateColors(slider);
        });
      }

      getWindowDimensions() {
        return {
          screenWidth: window.innerWidth,
          screenHeight: window.innerHeight,
        };
      }

      getDimensions() {
        return {
          width: this.offsetWidth,
          height: this.offsetHeight,
        };
      }

      isWindowMobile() {
        return window.innerWidth <= 1024;
      }

      isWindowDesktop() {
        return window.innerWidth > 1024;
      }

      /**
       * Update config if the device width changes.
       */
      detectDeviceMode(slider) {
        const wrapper = slider.container.parentElement;

        if (wrapper.isWindowMobile()) {
          if (!wrapper.classList.contains("media-carousel--device-mobile")) {
            if (wrapper.classList.contains("media-carousel--device-desktop")) {
              wrapper.classList.remove("media-carousel--device-desktop");
            }
            wrapper.classList.add("media-carousel--device-mobile");
            slider.update(wrapper.getConfig());
          }
        } else {
          if (!wrapper.classList.contains("media-carousel--device-desktop")) {
            if (wrapper.classList.contains("media-carousel--device-mobile")) {
              wrapper.classList.remove("media-carousel--device-mobile");
            }
            wrapper.classList.add("media-carousel--device-desktop");
            slider.update(wrapper.getConfig());
          }
        }
      }

      responsivePlugin(slider) {
        const wrapper = slider.container.parentElement;

        slider.on("created", () => {
          wrapper.detectDeviceMode(slider);
        });
        slider.on(
          "updated",
          debounce(() => {
            wrapper.detectDeviceMode(slider);
          }, 100)
        );
        window.addEventListener(
          "resize",
          debounce(() => {
            wrapper.detectDeviceMode(slider);
          }, 100)
        );
      }

      /**
       * Autoplay the slides.
       */
      autoplayPlugin(slider) {
        const wrapper = slider.container.parentElement;
        const toggle = wrapper.querySelector(".keen-toggle");
        let timeout;
        let mouseOver = false;
        let userPaused = false;

        function clearNextTimeout() {
          clearTimeout(timeout);
        }

        function nextTimeout() {
          clearTimeout(timeout);
          if (mouseOver || userPaused) return;
          timeout = setTimeout(() => {
            slider.next();
          }, wrapper.getAttribute("autoplay-speed"));
        }

        slider.on("created", () => {
          slider.container.addEventListener("mouseover", () => {
            mouseOver = true;
            clearNextTimeout();
          });
          slider.container.addEventListener("mouseout", () => {
            if (!userPaused) {
              mouseOver = false;
              nextTimeout();
            }
          });

          toggle?.addEventListener("click", () => {
            if (!userPaused) {
              clearNextTimeout();
              userPaused = true;
              toggle.setAttribute("paused", true);
            } else {
              nextTimeout();
              userPaused = false;
              toggle.setAttribute("paused", false);
            }
            toggle.blur();
          });

          nextTimeout();
        });

        slider.on("dragStarted", clearNextTimeout);
        slider.on("animationEnded", nextTimeout);
        slider.on("updated", nextTimeout);
      }

      /**
       * Show nav dots
       */
      dotsPlugin(slider) {
        const wrapper = slider.container.parentElement;
        const dots = wrapper.querySelector(".keen-dots");

        function dotMarkup() {
          if (dots) {
            dots.innerHTML = "";
            slider.track.details.slides.forEach((_e, idx) => {
              var dot = document.createElement("button");
              dot.classList.add("keen-dots__dot");
              dot.setAttribute("type", "button");
              dot.addEventListener("click", () => slider.moveToIdx(idx));
              dots.appendChild(dot);
            });
          }
        }

        function updateClasses() {
          if (dots) {
            const slide = slider.track.details.rel;
            Array.from(dots.children).forEach(function (dot, idx) {
              idx === slide
                ? dot.classList.add("keen-dots__dot--active")
                : dot.classList.remove("keen-dots__dot--active");
            });
          }
        }

        slider.on("created", () => {
          dotMarkup();
          updateClasses();
        });
        slider.on("optionsChanged", () => {
          dotMarkup();
          updateClasses();
        });
        slider.on("slideChanged", () => {
          updateClasses();
        });
      }

      /**
       * Show nav (prev/next) buttons
       */
      navPlugin(slider) {
        const wrapper = slider.container.parentElement;
        const nav = wrapper.querySelector(".keen-nav");
        const navPrevious = wrapper.querySelector(".keen-nav__previous");
        const navNext = wrapper.querySelector(".keen-nav__next");

        function initEvents() {
          if (nav) {
            navPrevious?.addEventListener("click", (event) => {
              event.preventDefault();
              slider.prev();
            });
            navNext?.addEventListener("click", (event) => {
              event.preventDefault();
              slider.next();
            });
          }
        }

        function updateNav() {
          if (
            slider.slides.length === 1 ||
            wrapper.getAttribute("loop") !== "true"
          ) {
            if (slider.track.details.rel === slider.track.details.maxIdx) {
              wrapper.classList.add("keen-nav--last-slide-active");
            } else {
              wrapper.classList.remove("keen-nav--last-slide-active");
            }

            if (slider.track.details.rel === slider.track.details.minIdx) {
              wrapper.classList.add("keen-nav--first-slide-active");
            } else {
              wrapper.classList.remove("keen-nav--first-slide-active");
            }
          }
        }

        slider.on("created", () => {
          initEvents();
          updateNav();
        });
        slider.on("optionsChanged", () => {
          updateNav();
        });
        slider.on("slideChanged", () => {
          updateNav();
        });
      }
    }
  );
}
